// A synchronous, best-effort answer to "was this browser signed in recently?".
//
// Firebase only reports auth state asynchronously (see AuthContext), which means
// anything gated on it cannot render until a network round-trip finishes. The
// marketing pages don't depend on auth at all, so gating them that way hid them
// from crawlers and from prerendering. This hint lets "/" decide what to render
// during the very first synchronous render instead.
//
// This is a rendering hint, NOT a security boundary. It is trivially forgeable
// and says nothing about whether a session is still valid — every real
// authorization decision stays with Firebase and the backend.

// public/index.html reads this key too, in an inline script. Keep them in step.
const SESSION_HINT_KEY = "bread.hasSession";

export function hasSessionHint(): boolean {
  try {
    return window.localStorage.getItem(SESSION_HINT_KEY) === "1";
  } catch {
    // Private browsing and blocked site data both throw here. Falling back to
    // "no session" is the safe default: the visitor sees the landing page for a
    // moment and is then redirected once Firebase resolves.
    return false;
  }
}

export function setSessionHint(hasSession: boolean): void {
  try {
    if (hasSession) {
      window.localStorage.setItem(SESSION_HINT_KEY, "1");
    } else {
      window.localStorage.removeItem(SESSION_HINT_KEY);
    }
  } catch {
    // Nothing to do: the hint is an optimization, so losing it only costs a
    // brief landing-page flash for a signed-in user.
  }
}
